import { render, staticRenderFns } from "./EcommercePodcastsTable.vue?vue&type=template&id=0272d319&scoped=true&"
import script from "./EcommercePodcastsTable.vue?vue&type=script&lang=js&"
export * from "./EcommercePodcastsTable.vue?vue&type=script&lang=js&"
import style0 from "./EcommercePodcastsTable.vue?vue&type=style&index=0&id=0272d319&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0272d319",
  null
  
)

export default component.exports